import { useEffect, useState } from "react";
import styles from "./CompanyPage.module.css";
import useNotification from "../../../hooks/useNotification";
import React from "react";
import { ENTERPRISE } from "../../../urlConfig";
import CustomBreadcrumb from "../../CommonComponents/CustomBreadcrumb";
import CompanyDetails from "./CompanyDetails";
import CompanyDetails2 from "./CompanyDetails2";
import CompanyActiveJobsListing from "./CompanyActiveJobsListing";
import EnterpriseServices from "../../../services/EnterpriseServices";
import { useLocation } from "react-router-dom";

const CompanyPage = () => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState({});
  const location = useLocation();

  const BreadcrumbOptions = [
    {
      title: "Enterprise",
      link: ENTERPRISE,
    },
    {
      title: companyData.companyName || "Company Name",
    },
  ];

  useEffect(() => {
    fetchUserOverviewData();
  }, []);

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const fetchUserOverviewData = async () => {
    setLoading(true);
    const res = await EnterpriseServices.getCompanyById(
      location.pathname.split("/")[3]
    );

    if (res) {
      if (res.statusCode === 1) {
        setCompanyData(res.data);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  return (
    <div className={styles.page_wrap}>
      <CustomBreadcrumb options={BreadcrumbOptions} />
      <CompanyDetails
        data={companyData}
        loading={loading}
        refatchData={fetchUserOverviewData}
      />
      <CompanyDetails2
        data={companyData}
        loading={loading}
        refatchData={fetchUserOverviewData}
      />
      <CompanyActiveJobsListing id={location.pathname.split("/")[3]} />
    </div>
  );
};

export default CompanyPage;
